<template>
  <!-- <v-container justify-space-between>
    <v-stepper
      v-model="e1"
      alt-labels
      class="elevation-0"
      v-if="!paymentSuccessful"
    >
      <v-stepper-header class="elevation-0">
        <v-stepper-step :complete="e1 > 1" step="1">
          Search Info
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">
          Additional Info
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">
          Order Summary
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="4">
          Checkout
        </v-stepper-step>
      </v-stepper-header>
      <v-divider></v-divider>
      <v-stepper-items>
        <v-stepper-content step="1" class="py-0">
          <v-form
            ref="searchInformationForm"
            v-model="searchInformationFormValid"
            lazy-validation
          >
            <v-row>
              <v-col>
                <h2>Property Address</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6" cols="12">
                <vuetify-google-autocomplete
                  ref="address"
                  id="map"
                  label="Address"
                  classname="form-control"
                  v-on:placechanged="getAddressData"
                  v-model="form.address"
                  country="us"
                  placeName
                  placeholder=""
                  outlined
                  dense
                  :fields="'address_components'"
                  required
                  maxlength="255"
                  :rules="rules.address"
                  @input="orderStarted"
                ></vuetify-google-autocomplete>
              </v-col>
              <v-col sm="6" cols="12">
                <v-text-field
                  name="address2"
                  label="Ste, Apt, Etc."
                  id="address2"
                  v-model="form.address2"
                  outlined
                  dense
                  maxlength="255"
                  :rules="rules.address2"
                ></v-text-field>
              </v-col>
              <v-col sm="4" cols="12">
                <v-text-field
                  name="city"
                  label="City"
                  id="city"
                  v-model="form.city"
                  outlined
                  dense
                  required
                  maxlength="255"
                  :rules="rules.city"
                ></v-text-field>
              </v-col>
              <v-col sm="4" cols="12">
                <v-select
                  name="state"
                  label="State"
                  id="state"
                  :items="states"
                  item-text="name"
                  item-value="name"
                  v-model="form.state"
                  outlined
                  dense
                  required
                  :rules="rules.state"
                ></v-select>
              </v-col>
              <v-col sm="4" cols="12">
                <v-text-field
                  name="zip"
                  label="Zip"
                  id="zip"
                  v-model="form.zip"
                  outlined
                  dense
                  required
                  maxlength="5"
                  :rules="rules.zip"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h2>Product Type</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Product Type"
                  name="product"
                  id="product"
                  :items="products"
                  item-text="name"
                  item-value="name"
                  outlined
                  dense
                  v-model="form.productType"
                  required
                  :rules="rules.productType"
                ></v-select>
                <ProductDescriptions
                  :selectedProductType="form.productType"
                ></ProductDescriptions>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex">
                <v-spacer></v-spacer>
                <h2>Search Cost: ${{ searchPrice }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="!searchInformationFormValid"
                  @click="validateSearchInformationForm"
                >
                  Next
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2" class="py-0">
          <v-form
            ref="additionalInformationForm"
            v-model="additionalInformationFormValid"
            lazy-validation
          >
            <v-row>
              <v-col>
                <h2>Property Address</h2>
                <p class="mb-0">
                  {{ form.address }}
                  <span v-if="!!form.address2">, {{ form.address2 }}</span>
                  <br />
                  {{ form.city }}, {{ form.state }} {{ form.zip }}
                </p>
              </v-col>
            </v-row>
            <v-row
              v-if="
                ['Specific Mortgage Search', 'Document Retrieval'].includes(
                  form.productType
                )
              "
            >
              <v-col cols="12">
                <h2>Document Information</h2>
                Please provide this extra information that we require for a
                specific mortgage search.
              </v-col>
              <v-col cols="12">
                <v-select
                  clearable
                  label="Document Type"
                  name="documentTypes"
                  id="documentTypes"
                  :items="documentTypes"
                  item-text="name"
                  return-object
                  outlined
                  dense
                  v-model="form.requestedDocumentType"
                  required
                  :rules="rules.requestedDocumentTypes"
                  v-if="form.productType === 'Document Retrieval'"
                ></v-select>
                <v-currency-field
                  id="mortgageAmount"
                  label="Mortgage Amount"
                  name="mortgageAmount"
                  hint="Total amount of the mortgage tied to the documents you're requesting."
                  persistent-hint
                  outlined
                  dense
                  v-model="form.mortgageAmount"
                  required
                  v-if="form.requestedDocumentTypes && !form.requestedDocumentTypes.some((type) => {
                    return type && ['Affidavit', 'Power of Attorney'].includes(type.name);
                  })"
                  :rules="mortgageAmountRules"
                ></v-currency-field>
                <v-menu
                  ref="menu"
                  v-model="datePickerMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  v-if="form.requestedDocumentTypes && !form.requestedDocumentTypes.some((type) => {
                    return type && ['Affidavit', 'Power of Attorney'].includes(type.name);
                  })"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="pt-1"
                      multiple
                      clearable
                      label="Est. Recording Date"
                      hint="Estimated date the mortgage was recorded at the courthouse."
                      persistent-hint
                      name="estRecordingDate"
                      id="estRecordingDate"
                      outlined
                      dense
                      v-model="form.estimatedRecordingDate"
                      required
                      :rules="rules.estimatedRecordingDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @focus="onFocusDatePicker()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="form.estimatedRecordingDate"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1900-01-01"
                    @change="saveDatePickerValue"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  name="grantor-grantee"
                  label="Grantor/Grantee"
                  hint="The name of the person you expect to be on the document"
                  persistent-hint
                  id="grantor-grantee"
                  outlined
                  dense
                  required
                  :rules="rules.grantorGrantee"
                  v-model="form.grantorGrantee"
                ></v-text-field>
                <v-text-field
                  name="book"
                  label="Book #"
                  id="book"
                  outlined
                  dense
                  :rules="rules.bookNumber"
                  v-model="form.bookNumber"
                ></v-text-field>
                <v-text-field
                  name="page"
                  label="Page #"
                  id="page"
                  outlined
                  dense
                  :rules="rules.pageNumber"
                  v-model="form.pageNumber"
                ></v-text-field>
                <v-text-field
                  name="instrument"
                  label="Instrument #"
                  id="instrument"
                  outlined
                  dense
                  :rules="rules.instrumentNumber"
                  v-model="form.instrumentNumber"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h2>Additional Information</h2>
                Please provide any additional information you may have to aid us
                in our search.
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  name="parcel"
                  label="Parcel #"
                  id="parcel"
                  outlined
                  dense
                  v-model="form.parcelNumber"
                ></v-text-field>
                <v-text-field
                  name="owner-name"
                  label="Property Owner"
                  id="owner-name"
                  outlined
                  dense
                  v-model="form.propertyOwner"
                ></v-text-field>
                <v-textarea
                  name="additional-info"
                  label="Additional Info"
                  id="additional-info"
                  placeholder="Reference #'s, Comments, Etc."
                  outlined
                  dense
                  v-model="form.additionalInfo"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex">
                <v-spacer></v-spacer>
                <h2>Search Cost: ${{ searchPrice }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex">
                <v-btn @click="e1 = 1">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="!additionalInformationFormValid"
                  @click="validateAdditionalInformationForm"
                >
                  Next
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-form>
            <div class="text-h4 pb-3">{{ form.productType }} Order Summary</div>
            <h2>Property Address</h2>
            <p>
              {{ form.address }}
              <span v-if="!!form.address2">, {{ form.address2 }}</span>
              <br />
              {{ form.city }}, {{ form.state }} {{ form.zip }}
            </p>
            <h2
              class="pt-3"
              v-if="
                ['Specific Mortgage Search', 'Document Retrieval'].includes(
                  form.productType
                )
              "
            >
              Document Information
            </h2>
            <v-row
              v-if="
                ['Specific Mortgage Search', 'Document Retrieval'].includes(
                  form.productType
                )
              "
            >
              <v-col cols="auto">
                <div v-if="form.productType === 'Document Retrieval'">
                  Documents Requested:
                </div>
                <div>Mortgage Amount:</div>
                <div>Est. Recording Date:</div>
                <div>Grantor/Grantee:</div>
                <div>Book #:</div>
                <div>Page #:</div>
                <div>Instrument #:</div>
              </v-col>
              <v-col>
                <div v-if="form.productType === 'Document Retrieval'">
                  {{ form.requestedDocumentTypes.map((type) => type.name).join(', ') }}
                </div>
                <div>{{ form.mortgageAmount }}</div>
                <div>{{ form.estimatedRecordingDate }}</div>
                <div>{{ form.grantorGrantee }}</div>
                <div>{{ form.bookNumber }}</div>
                <div>{{ form.pageNumber }}</div>
                <div>{{ form.instrumentNumber }}</div>
              </v-col>
            </v-row>
            <h2 class="pt-3">Additional Information</h2>
            <v-row>
              <v-col cols="auto">
                <div>Parcel #:</div>
                <div>Property Owner</div>
                <div>Additional Info</div>
              </v-col>
              <v-col>
                <div>{{ form.parcelNumber }}</div>
                <div>{{ form.propertyOwner }}</div>
                <div>{{ form.additionalInfo }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex">
                <v-spacer></v-spacer>
                <h2>Search Cost: ${{ searchPrice }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex">
                <v-btn @click="e1 = 2">Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="startCheckout">Checkout</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-form v-if="!isAuthenticated && !signUpSuccessful && !checkoutMode">
            <v-row v-if="!showSignup && !showLogin">
              <v-col>
                <v-row>
                  <v-col>
                    <v-form
                      ref="guestCheckoutForm"
                      v-model="guestCheckoutFormValid"
                      lazy-validation
                    >
                      <v-text-field
                        outlined
                        dense
                        label="Email Address"
                        required
                        :rules="rules.email"
                        v-model="form.guestEmail"
                      ></v-text-field>
                      <v-btn
                        color="primary"
                        block
                        @click="validateGuestChecoutForm"
                      >
                        continue as guest
                      </v-btn>
                    </v-form>
                    <div class="text-overline text-center mt-3">or</div>
                    <v-btn
                      color="primary"
                      block
                      class="mt-3"
                      @click="showSignup = true"
                    >
                      sign up
                    </v-btn>
                    <v-btn block class="mt-3" @click="showLogin = true">
                      login
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="showSignup" no-gutters>
              <v-col>
                <sign-up-form
                  :outlined="true"
                  :dense="true"
                  :blockButton="true"
                  :textButton="false"
                ></sign-up-form>
              </v-col>
            </v-row>
            <v-row v-if="showLogin" no-gutters>
              <v-col>
                <login-form
                  :outlined="true"
                  :dense="true"
                  :blockButton="true"
                  :textButton="false"
                ></login-form>
              </v-col>
            </v-row>
          </v-form>
          <v-form
            v-if="
              isAuthenticated || signUpSuccessful || checkoutMode == 'guest'
            "
            ref="checkoutForm"
          >
            <v-row>
              <v-col>
                <h2>Coupon Code</h2>
              </v-col>
            </v-row>
            <v-row no-gutters class="px-5" align="center" justify="center">
              <v-col cols="12" md="6" lg="3">
                <v-text-field
                  v-model="promoCode"
                  label="Code"
                  dense
                  outlined
                  hide-details=""
                ></v-text-field>
              </v-col>
              <v-col class="pl-3" align-center>
                <v-btn
                  color="primary"
                  :disabled="!promoCode"
                  @click="validatePromoCode"
                >
                  Apply
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="px-5" v-if="form.promoCode">
              <v-col>
                Promo code "{{ form.promoCode.code }}" applied for
                <span v-if="form.promoCode.discountAmount">
                  ${{ form.promoCode.discountAmount }}
                </span>
                <span v-else>{{ form.promoCode.discountPercent }}%</span>
                off.
              </v-col>
            </v-row>
            <v-row no-gutters class="px-5" v-if="invalidPromoCode">
              <v-col class="red--text">
                Promo code invalid.
              </v-col>
            </v-row>
            <div v-if="searchPrice != '0.00'">
              <v-row>
                <v-col>
                  <h2>Payment Information</h2>
                </v-col>
              </v-row>
              <v-alert dense outlined type="error" v-if="!!this.cardErrors">
                Error processing payment method. Please check your information
                and try again.
              </v-alert>
              <v-row no-gutters class="px-5" v-if="isAuthenticated">
                <v-radio-group
                  v-model="selectedPaymentMethod"
                  style="min-width: 400px"
                >
                  <v-radio
                    v-for="paymentMethod in paymentMethods"
                    :value="paymentMethod"
                    :key="paymentMethod.id"
                  >
                    <template v-slot:label>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-img
                            :src="
                              `/icons/credit_cards/png/24/${paymentMethod.card.brand}.png`
                            "
                          ></v-img>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span class="text-capitalize font-weight-bold">
                              {{ paymentMethod.card.brand }}
                            </span>
                            ending in {{ paymentMethod.card.last4 }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            Expiration: {{ paymentMethod.card.expMonth }}/{{
                              paymentMethod.card.expYear
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-radio>
                  <v-radio :value="'NEW'">
                    <template v-slot:label>
                      <v-list-item>
                        <v-list-item-icon>
                          <v-icon>mdi-credit-card-plus-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content
                          v-show="selectedPaymentMethod === 'NEW'"
                          class="py-0 pt-1"
                        >
                          <v-stripe-card
                            class="pt-0 mt-0"
                            ref="stripeElementCard"
                            v-model="cardInformation"
                            :api-key="stripeApiKey"
                            dense
                          ></v-stripe-card>
                        </v-list-item-content>
                        <v-list-item-content
                          v-if="selectedPaymentMethod != 'NEW'"
                        >
                          <v-list-item-title>
                            New Payment Method
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-row>
              <v-row v-else class="px-5">
                <v-col>
                  <v-stripe-card
                    class="pt-0 mt-0"
                    ref="stripeElementCard"
                    v-model="cardInformation"
                    :api-key="stripeApiKey"
                    dense
                  ></v-stripe-card>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                class="px-5"
                v-show="selectedPaymentMethod === 'NEW'"
              >
                <v-checkbox
                  v-model="form.save_payment_info"
                  label="Save payment info for later?"
                ></v-checkbox>
              </v-row>
            </div>
            <v-row>
              <v-col>
                <h2>Terms of Service</h2>
              </v-col>
            </v-row>
            <v-row no-gutters class="px-5">
              <v-textarea
                v-model="termsOfUse"
                class="terms-of-use-text-area"
                readonly
                outlined
                @scroll="onTermsScroll"
                rows="12"
                :rules="rules.tosRules"
                :hint="
                  !tosRead
                    ? 'You must scroll to the end of the terms to continue.'
                    : ''
                "
                persistent-hint
              ></v-textarea>
              <v-checkbox
                class="mt-0"
                outlined
                @click.prevent="tosAgreed"
                v-model="form.termsAgreed"
              >
                <template v-slot:label class="d-block">
                  <div class="pl-3">
                    I agree to the Terms of Service and understand that any
                    search performed by RE Titles &amp; Deeds comes with no
                    warranty, and any use of the results of this search for
                    insured purposes is at my own risk.
                  </div>
                </template>
              </v-checkbox>
            </v-row>
            <v-btn
              block
              color="primary"
              @click="checkout"
              :disabled="
                submitted ||
                  !paymentInfoValid ||
                  (searchPrice != '0.00' &&
                    $refs.stripeElementCard.errorBucket.length > 0) ||
                  !form.termsAgreed
              "
            >
              PAY ${{ searchPrice }}
            </v-btn>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div v-else>
      <v-row align="center" justify="center">
        <h2>Order Successfully Submitted</h2>
      </v-row>
      <v-row align="center" justify="center">
        <p>
          You will receive an email shortly with an invoice as well as a summary
          of your order. You will also receive periodic status updates via email
          as your order is completed.
        </p>
        <p>
          You can also view the status of your order on our dashboard by
          <router-link to="/sign-up">registering</router-link>
          an account with the email address used during checkout.
        </p>
      </v-row>
    </div>
  </v-container> -->
  <v-container>
    <p style="font-size: x-large; font-weight: bold; margin-left: 20%; margin-right: 20%;">RE Titles & Deeds is currently not accepting new orders at this time. We apologize for the inconvenience.<br>If you need to access a past order please check your order dashboard.</p>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import {
  fieldRequired,
  maxLength,
  validEmail,
  minValue,

} from "@/form-rules/index";
import { obtainPaymentIntent, checkPromoCode } from "@/services/api/payments";
import { placeOrder } from "@/services/api/orders";
import TERMS from "@/assets/terms-and-conditions";


export default {
  components: { },
  data: function() {
    return {
      form: {
        address: "",
        address2: "",
        streetNumber: "",
        city: "",
        state: "",
        zip: "",
        productType: "",

        requestedDocumentType: "",
        requestedDocumentTypes: [],
        mortgageAmount: null,
        grantorGrantee: "",
        bookNumber: "",
        pageNumber: "",
        instrumentNumber: "",
        estimatedRecordingDate: "",

        parcelNumber: "",
        propertyOwner: "",
        additionalInfo: "",

        termsAgreed: false,

        promoCode: null,

        guestEmail: "",
        signUpEmail: "",
      },

      rules: {
        address: [fieldRequired("Address is required."), maxLength(255)],
        address2: [maxLength(255)],
        city: [fieldRequired("City is required."), maxLength(255)],
        state: [fieldRequired("State is required.")],
        zip: [fieldRequired("Zip code is required."), maxLength(5)],
        productType: [fieldRequired("You must select a product type.")],

        email: [
          fieldRequired("Email is required when checking out as a guest,"),
          validEmail(),
        ],

        requestedDocumentTypes: [
          fieldRequired(
            "You must select at least 1 document type for a document retrieval order."
          ),
        ],
        mortgageAmount: [
          fieldRequired(
            "Mortgage amount is required for document retrieval orders."
          ),
          minValue(0, "Mortgage"),
        ],
        estimatedRecordingDate: [
          fieldRequired(
            "Est. recording date must be provided for a document retrieval order."
          ),
        ],
        tosRules: [
          (v) =>
            (!!v && !!this.tosRead) ||
            "You must scroll to the end of the terms to continue.",
        ],

        grantorGrantee: [
          fieldRequired("Grantor/Grantee is required when ordering a document document retrieval order."),
          maxLength(255),
        ],
        bookNumber: [maxLength(255)],
        pageNumber: [maxLength(255)],
        instrumentNumber: [maxLength(255)],

        save_payment_info: false,
      },

      promoCode: "",
      promoCodeValid: false,
      invalidPromoCode: false,

      tosRead: false,
      termsOfUse: TERMS,

      e1: 1,
      datePickerMenu: false,

      checkoutMode: null,
      showSignup: false,
      showLogin: false,

      guestCheckoutFormValid: undefined,
      searchInformationFormValid: undefined,
      additionalInformationFormValid: undefined,
      checkoutFormValid: undefined,

      billingInfo: {
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
      },
      selectedPaymentMethod: null,
      submitted: false,
      stripeApiKey: process.env.VUE_APP_STRIPE_API_KEY,
      clientSecret: null,
      cardInformation: null,
      paymentInformation: null,
      cardErrors: null,
      paymentSuccessful: null,
      orderNumber: null,
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    signUpSuccessful() {
      return this.$store.state.auth.signUpSuccessful;
    },
    signUpEmail() {
      return this.$store.state.auth.signUpEmail;
    },
    products() {
      return this.$store.state.products.products;
    },
    states() {
      return this.$store.state.states.states;
    },
    documentTypes() {
      return this.$store.state.products.documentTypes;
    },
    paymentMethods() {
      if (this.isAuthenticated) {
        return this.$store.state.auth.user.djstripeCustomers[0].paymentMethods;
      }
      return [];
    },
    paymentInfoValid() {
      if (
        (this.searchPrice == "0.00") |
        (this.selectedPaymentMethod != null &&
          this.selectedPaymentMethod != "NEW") |
        (this.cardInformation != null)
      ) {
        return true;
      }
      return false;
    },
    searchPrice() {
      try {
        if (this.form.productType && this.form.state) {
          let product = this.products.find(
            (product) => product.name === this.form.productType
          );
          let price = product.prices.find(
            (price) => price.state.name === this.form.state
          ).price;
          if (this.form.promoCode != null) {
            if (this.form.promoCode.discountAmount) {
              price = price - this.form.promoCode.discountAmount;
            } else {
              price =
                price - price * (this.form.promoCode.discountPercent / 100);
            }
            return price.toFixed(2);
          }
          return price;
        } else {
          return "--.--";
        }
      } catch {
        return "--.--";
      }
    },
    receiptEmail() {
      if (this.isAuthenticated) {
        return this.$store.state.auth.user.email;
      } else if (this.form.guestEmail != "") {
        return this.form.guestEmail;
      } else if (this.form.signUpEmail != "") {
        return this.form.signUpEmail;
      } else {
        return null;
      }
    },
    mortgageAmountRules() {
      if (
        this.form.requestedDocumentTypes.length == 1 &&
        this.form.requestedDocumentTypes[0]?.name == "Associated Deed"
      ) {
        return [];
      } else {
        return [
          fieldRequired(
            "Mortgage amount is required for document retrieval orders."
          ),
          minValue(0, "Mortgage"),
        ];
      }
    },
  },
  methods: {
    orderStarted() {
      if (!this.$store.state.orders.orderStarted) {
        this.$store.commit("orders/SET_ORDER_STARTED", true);
      }
    },
    saveDatePickerValue(date) {
      this.$refs.menu.save(date);
    },
    onFocusDatePicker() {
      !this.datePickerMenu &&
        setTimeout(() => (this.datePickerMenu = true), 250);
    },
    getAddressData: function(addressData) {
      this.form.address = `${addressData.street_number} ${addressData.route}`;
      this.form.city = addressData.locality;
      this.form.state = this.states.find(
        (state) =>
          state.abbreviation === addressData.administrative_area_level_1
      ).name;
      this.form.zip = addressData.postal_code;
    },
    getBillingAddressData: function(addressData) {
      this.billingInfo.address = `${addressData.street_number} ${addressData.route}`;
      this.billingInfo.city = addressData.locality;
      this.billingInfo.state = this.states.find(
        (state) =>
          state.abbreviation === addressData.administrative_area_level_1
      ).name;
      this.billingInfo.zip = addressData.postal_code;
    },
    validateSearchInformationForm() {
      const formValid = this.$refs.searchInformationForm.validate();
      if (formValid) {
        this.e1 = 2;
      }
    },
    validateAdditionalInformationForm() {
      const formValid = this.$refs.additionalInformationForm.validate();
      if (formValid) {
        this.e1 = 3;
      }
    },
    startCheckout() {
      this.e1 = 4;
    },
    validateGuestChecoutForm() {
      const formValid = this.$refs.guestCheckoutForm.validate();
      if (formValid) {
        this.checkoutMode = "guest";
      }
    },
    chargeExistingCard() {
      obtainPaymentIntent({
        searchCost: this.searchPrice,
        orderNumber: this.orderNumber,
        paymentMethodId: this.selectedPaymentMethod.id,
      }).then((resp) => {
        if (resp.error) {
          this.submitted = false;
          this.cardErrors = resp.error;
        } else {
          this.paymentInformation = resp;
          this.paymentSuccessful = true;
          this.$store.commit("orders/SET_ORDER_STARTED", false);
          if (this.isAuthenticated) {
            this.$router.push(`/dashboard/orders/${this.orderNumber}`);
          }
        }
      });
    },
    tosAgreed() {
      if (this.tosRead) {
        this.form.termsAgreed = true;
        this.$refs.checkoutForm.validate();
      } else {
        this.$nextTick(() => {
          this.$refs.checkoutForm.validate();
          this.form.termsAgreed = false;
        });
      }
    },
    chargeNewCard() {
      obtainPaymentIntent({
        searchCost: this.searchPrice,
        orderNumber: this.orderNumber,
        paymentMethodId: null,
      }).then((resp) => {
        this.clientSecret = resp.clientSecret;
        this.$refs.stripeElementCard.stripe
          .confirmCardPayment(this.clientSecret, {
            payment_method: {
              card: this.$refs.stripeElementCard.card,
            },
          })
          .then((resp) => {
            if (resp.error) {
              this.submitted = false;
              this.cardErrors = resp.error;
            } else {
              this.paymentInformation = resp;
              this.paymentSuccessful = true;
              this.$store.commit("orders/SET_ORDER_STARTED", false);
              if (this.isAuthenticated) {
                this.$router.push(`/dashboard/orders/${this.orderNumber}`);
              }
            }
          });
      });
    },
    validatePromoCode() {
      let data = {
        stripeCustomerId: null,
        promoCode: this.promoCode,
      };
      if (this.isAuthenticated) {
        data[
          "stripeCustomerId"
        ] = this.$store.state.auth.user.djstripeCustomers[0].id;
      }
      checkPromoCode(data)
        .then((resp) => {
          this.promoCode = null;
          this.form.promoCode = resp;
        })
        .catch(() => {
          this.invalidPromoCode = true;
        });
    },
    checkout() {
      this.submitted = true;
      if (this.orderNumber) {
        if (this.selectedPaymentMethod && this.selectedPaymentMethod != "NEW") {
          this.chargeExistingCard();
        } else {
          this.chargeNewCard();
        }
      } else {
        placeOrder(this.form)
          .then((resp) => {
            this.orderNumber = resp.orderNumber;
            if (resp.searchCost == "0.00") {
              this.paymentSuccessful = true;
              this.$store.commit("orders/SET_ORDER_STARTED", false);
              if (this.isAuthenticated) {
                this.$router.push(`/dashboard/orders/${this.orderNumber}`);
              }
            } else {
              if (
                this.selectedPaymentMethod &&
                this.selectedPaymentMethod != "NEW"
              ) {
                this.chargeExistingCard();
              } else {
                this.chargeNewCard();
              }
            }
          })
          .catch(() => {
            this.submitted = false;
          });
      }
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.address.$refs.textField.$refs.input.focus();
      });
    },
    onTermsScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.tosRead = true;
        this.$refs.signUpForm.validate();
      }
    },
  },

  watch: {
    datePickerMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    signUpEmail(val) {
      this.form.signUpEmail = val;
    },
    "form.requestedDocumentType"(val) {
      this.form.requestedDocumentTypes = [val];
      this.validateSearchInformationForm();
    },
  },

  mounted() {
    this.focusInput();
    for (const [key, value] of Object.entries(this.$route.query)) {
      this.form[key] = value;
    }
  },
};
</script>

<style>
.terms-of-use-text-area textarea {
  font-size: 0.8em !important;
  line-height: 1rem !important;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.terms-of-use-text-area textarea::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.terms-of-use-text-area textarea {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
